import Validator from "../utils/validator"

class Footer {
  constructor() {
    this.Footer()
  }

  Footer() {
    document
      .querySelector(".footer__emailCta")
      .addEventListener("click", () => {
        if (!this.checkIfOkToValidate()) return
        this.validateForm()
      })

    document
      .querySelector(`#footer__emailInput`)
      .addEventListener("keyup", (event) => {
        if (
          document
            .querySelector(".footer__emailInputWrapper")
            .classList.contains("error")
        ) {
          document
            .querySelector(".footer__emailInputWrapper")
            .classList.remove("error")
        }
      })
  }

  checkIfOkToValidate() {
    if (
      document.querySelector(`#footer__emailInput`).classList.contains("busy")
    )
      return false

    return true
  }

  validateForm() {
    const validator = new Validator()
    const a = validator.checkEmail("#footer__emailInput")

    if (!a) return
    this.submitForm()
  }

  async submitForm() {
    this.lockFormForSubmission("agents")

    try {
      const formData = new FormData()
      formData.append("action", "hubspot_submit_newsletter")
      formData.append(
        "email",
        document.querySelector("#footer__emailInput").value
      )

      const rData = await fetch(main_wp.ajax_url, {
        method: "POST",
        credentials: "same-origin",
        body: formData,
      })
      const response = await rData.json()
      if (response.status_code == 200) {
        this.showFormSuccess()
      } else {
        this.showFormFail(response)
      }

      this.unlockFormFromSubmission()
    } catch (error) {
      console.log(error)
      this.unlockFormFromSubmission()
    }
  }

  lockFormForSubmission() {
    document.querySelector(`#footer__emailInput`).classList.add("busy")
  }

  unlockFormFromSubmission() {
    document.querySelector(`#footer__emailInput`).classList.remove("busy")
  }

  showFormSuccess() {
    document.querySelector(`#footer__emailInput`).value = ""
    document
      .querySelector(`#footer__emailInput`)
      .setAttribute("placeholder", "Thanks, your email has been submitted!")

    setTimeout(() => {
      document
        .querySelector(`#footer__emailInput`)
        .setAttribute("placeholder", "Email")
    }, 5000)
  }

  showFormFail(response) {
    console.log(response)
  }
}

export default Footer
